type ImageFileTypeReference = Exclude<File_StonecodeFileTypeReference,
	'map_json'
	| 'geodata_json'
	| 'map_geodata_json'
	| 'map_image'
	| 'map_geodata_compiled_json'
	| 'project_template_logo'
>;
const notImageFileTypeReference: File_StonecodeFileTypeReference[] = ['map_json', 'geodata_json', 'map_geodata_json', 'map_image', 'map_geodata_compiled_json'];

export function getFileImageRequirements(fileReference: File_StonecodeFileTypeReference): ImageRequirements | undefined {
	if (notImageFileTypeReference.includes(fileReference)) {
		return undefined;
	}

	const imageFileTypeReference = fileReference as ImageFileTypeReference;
	return {
		aspect: aspects[imageFileTypeReference],
		minDimensions: minDimensions[imageFileTypeReference],
	};
}

const aspects: { [key in ImageFileTypeReference]: string } = {
	'place_image': '1 / 1',
	// Le format de la vignette de l'accueil, partagé avec la capture automatique.
	'project_image': '16 / 9',
};

const minDimensions: { [key in ImageFileTypeReference]: { width: number, height: number } } = {
	'place_image': { width: 100, height: 100 },
	'project_image': { width: 320, height: 180 },
};